var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rbInputContainer", class: _vm.errorClasses },
    [
      _c(
        "label",
        { staticClass: "rbInputLabel", attrs: { for: _vm.forId } },
        [
          _vm._t("label"),
          _vm.$slots.hint
            ? _c(
                "span",
                { staticClass: "rbInputLabelHint" },
                [_vm._t("hint")],
                2
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._t("default"),
      _c(
        "div",
        { staticClass: "rbInputError" },
        [
          _c("transition", { attrs: { name: "rbInputError" } }, [
            _vm.error
              ? _c("div", [_vm._v(" " + _vm._s(_vm.error) + " ")])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._t("atEnd"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }